import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store/store";
import "./index.css";
import { setup } from "@onmo/auth";
import { configureI18n } from "./configs/i18n";

configureI18n();
setup(store, { onLoad: "check-sso" }); // init Keycloak

const root = document.getElementById("root") as HTMLElement;
createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
